
//-----------Principal-----------
import Plantilla from '@/components/Audiencias/Programacion/Comun/Plantilla.vue';

//-----------Programacion de audiencias -----------
import Programacion from '@/components/Audiencias/Programacion/CProgramacion.vue';
//-----------Manejo de audiencias -----------
import Manejo from '@/components/Audiencias/Manejo/CManejo.vue';
//-----------Programacion de audiencias -----------
import Registro from '@/components/Audiencias/Registro/CRegistroAudiencias.vue';
//-----------Consulta Audiencias ----------------
import ConsultaJuez from '@/components/Audiencias/Consulta/ConsultaJuez.vue';
import AgendaControlAuxInfo from '@/components/Audiencias/AgendaControlAuxInfromatica/AgendaControlAuxInformatica.vue';
//-----------Lista de audiencias -----------
import ListaAudiencias from '@/components/Audiencias/ListaAudiencias/CListaDeAudiencias.vue';
//-----------Lista de audiencias -----------
import ConsultaAdministracion from '@/components/Audiencias/ConsultaAdministracion/CConsultaAdministracion.vue';
//-----------lista de audiencias -----------
import Modulos from '@/components/Audiencias/Menu/CMenuModulos.vue';

//Se crea la lista de paths
const Audiencias = [
  {
    path: '/Audiencias/', component: Plantilla, children:[
      { name: 'modulosAudienciasTemporal', path: 'Modulos', component: Modulos },
      { name: 'ProgramacionAudienciasTemporal', path: 'Programacion', component: Programacion },
      { name: 'ManejoTemporal', path: 'Manejo', component: Manejo },
      { name: 'RegistroAudienciasTemporal', path: 'Registro', component: Registro },
      { name: 'ConsultaJuezAudienciasTemporal', path: 'ConsultaJuez', component: ConsultaJuez },
      { name: 'ListaAudienciasAudienciasTemporal', path: 'ListaAudiencias', component: ListaAudiencias },
      { name: 'AgendaControlAuxAudienciasTemporal', path: 'AgendaControlAuxInfo', component: AgendaControlAuxInfo },
      { name: 'ConsultaAdministracionAudienciasTemporal', path: 'ConsultaAdministracion', component: ConsultaAdministracion }
    ]
  }
];

//Se regresa la lista de paths
export default Audiencias;


// WEBPACK FOOTER //
// ./src/router/AudienciasTemporal.js